// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.elder-transactions-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

/* === HEADER (Reused structure) === */
.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.transactions-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 900px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === FILTER BUTTONS === */
.filter-buttons-container {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
    background: white;
    padding: 0.75rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
    overflow-x: auto;
    /* Allows swiping on very small phones */
}

.filter-btn {
    flex: 1 1;
    padding: 1rem;
    border: none;
    background: #f8fafc;
    color: #64748b;
    font-size: 1.1rem;
    font-weight: 700;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.filter-btn:hover:not(.active):not(.active-paid):not(.active-received) {
    background: #f1f5f9;
    color: #334155;
}

/* Specific Active States for visual clarity */
.filter-btn.active {
    background: #1e293b;
    color: white;
}

.filter-btn.active-paid {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.filter-btn.active-received {
    background: #f0fdf4;
    color: #059669;
    border: 1px solid #a7f3d0;
}

/* === LIST STYLES === */
.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.tx-card {
    /* Extending .elder-list-card from previous designs */
    background: white;
    border-radius: 16px;
    padding: 1.25rem 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

/* Inside the strip card */
.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
}

.icon-wrapper {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.blue-icon {
    background: #eff6ff;
    color: #3b82f6;
}

.green-icon {
    background: #f0fdf4;
    color: #10b981;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.elder-card-title {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
    font-weight: 700;
}

.tx-details-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.tx-detail-text {
    font-size: 1.05rem;
    color: #334155;
}

.font-semibold {
    font-weight: 600;
}

.stat-divider {
    color: #cbd5e1;
    font-size: 1.2rem;
}

.tx-meta-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: #64748b;
    margin-top: 0.2rem;
}

.handled-by {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

/* Amount & Status Right Side */
.tx-amount-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
    flex-shrink: 0;
}

.tx-amount {
    font-size: 1.4rem;
    font-weight: 800;
    display: flex;
    align-items: center;
}

.text-blue {
    color: #2563eb;
}

.text-green {
    color: #059669;
}

.rupee-inline {
    margin: 0 0.1rem 0 0.1rem;
}

.status-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.75rem;
    border-radius: 99px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-success {
    background: #dcfce7;
    color: #15803d;
}

.badge-warning {
    background: #fef3c7;
    color: #b45309;
}

.badge-error {
    background: #fee2e2;
    color: #b91c1c;
}

/* Empty States & Loading */
.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 3rem;
    text-align: center;
    font-size: 1.2rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.elder-btn-primary {
    background: #2563eb;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
}

/* === PAGINATION === */
.elder-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f1f5f9;
    border: none;
    color: #334155;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 1.1rem;
    color: #475569;
    font-weight: 600;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .transactions-main-content {
        padding: 0 1.25rem 3rem 1.25rem;
    }

    .filter-buttons-container {
        padding: 0.5rem;
        gap: 0.5rem;
    }

    .filter-btn {
        padding: 0.75rem 1rem;
        font-size: 1rem;
    }

    .tx-card {
        flex-direction: column;
        align-items: flex-start;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .list-card-left {
        width: 100%;
        align-items: flex-start;
    }

    .icon-wrapper {
        height: 48px;
        width: 48px;
    }

    .tx-amount-section {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #f1f5f9;
        padding-top: 1rem;
    }

    .elder-pagination {
        flex-direction: column;
        gap: 1.5rem;
    }

    .page-btn {
        width: 100%;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/Transactions.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;IAC1C,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qDAAqD;IACrD,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":["/* Container matching Dashboard gradient */\n.elder-transactions-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n/* === HEADER (Reused structure) === */\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.transactions-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 900px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === FILTER BUTTONS === */\n.filter-buttons-container {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 2rem;\n    background: white;\n    padding: 0.75rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    overflow-x: auto;\n    /* Allows swiping on very small phones */\n}\n\n.filter-btn {\n    flex: 1;\n    padding: 1rem;\n    border: none;\n    background: #f8fafc;\n    color: #64748b;\n    font-size: 1.1rem;\n    font-weight: 700;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.filter-btn:hover:not(.active):not(.active-paid):not(.active-received) {\n    background: #f1f5f9;\n    color: #334155;\n}\n\n/* Specific Active States for visual clarity */\n.filter-btn.active {\n    background: #1e293b;\n    color: white;\n}\n\n.filter-btn.active-paid {\n    background: #eff6ff;\n    color: #2563eb;\n    border: 1px solid #bfdbfe;\n}\n\n.filter-btn.active-received {\n    background: #f0fdf4;\n    color: #059669;\n    border: 1px solid #a7f3d0;\n}\n\n/* === LIST STYLES === */\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.tx-card {\n    /* Extending .elder-list-card from previous designs */\n    background: white;\n    border-radius: 16px;\n    padding: 1.25rem 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n/* Inside the strip card */\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n}\n\n.icon-wrapper {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.blue-icon {\n    background: #eff6ff;\n    color: #3b82f6;\n}\n\n.green-icon {\n    background: #f0fdf4;\n    color: #10b981;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.elder-card-title {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.tx-details-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.tx-detail-text {\n    font-size: 1.05rem;\n    color: #334155;\n}\n\n.font-semibold {\n    font-weight: 600;\n}\n\n.stat-divider {\n    color: #cbd5e1;\n    font-size: 1.2rem;\n}\n\n.tx-meta-info {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    font-size: 0.9rem;\n    color: #64748b;\n    margin-top: 0.2rem;\n}\n\n.handled-by {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n/* Amount & Status Right Side */\n.tx-amount-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.5rem;\n    flex-shrink: 0;\n}\n\n.tx-amount {\n    font-size: 1.4rem;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.rupee-inline {\n    margin: 0 0.1rem 0 0.1rem;\n}\n\n.status-badge {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.75rem;\n    border-radius: 99px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-success {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.badge-warning {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.badge-error {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n/* Empty States & Loading */\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 3rem;\n    text-align: center;\n    font-size: 1.2rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.elder-btn-primary {\n    background: #2563eb;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n/* === PAGINATION === */\n.elder-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #f1f5f9;\n    border: none;\n    color: #334155;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 1.1rem;\n    color: #475569;\n    font-weight: 600;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .transactions-main-content {\n        padding: 0 1.25rem 3rem 1.25rem;\n    }\n\n    .filter-buttons-container {\n        padding: 0.5rem;\n        gap: 0.5rem;\n    }\n\n    .filter-btn {\n        padding: 0.75rem 1rem;\n        font-size: 1rem;\n    }\n\n    .tx-card {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .list-card-left {\n        width: 100%;\n        align-items: flex-start;\n    }\n\n    .icon-wrapper {\n        height: 48px;\n        width: 48px;\n    }\n\n    .tx-amount-section {\n        width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1rem;\n    }\n\n    .elder-pagination {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .page-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
